import React from "react";
//#region types
import { TimeReportingProjectCategoryListProps } from "models/propTypes/timeReportingProjectPropTypes";
import { TranslationKeys } from "translations";
import { TimeReportingProjectFormTypes } from "models/formTypes";
//#endregion
//#region components
//#endregion
import { DateHelper, LocalizationHelperInstance } from "utils/helpers";

const NumberOfProjectCategoryMembers: React.FC<TimeReportingProjectCategoryListProps> = (props) => {
  const isActive = (endDate?: Date) => {
    const isActive = endDate ? DateHelper.isBefore(DateHelper.today(), new Date(endDate)) : true;

    return isActive;
  };

  const { timeReportingProject, currentCategory } = props;
  const getLabel = (project: TimeReportingProjectFormTypes.Create) => {
    if (project?.projectCategoryMembers == null) return "";

    const numberOfMembersInCategory = project?.projectCategoryMembers?.filter(
      (categoryMember) =>
        // eslint-disable-next-line eqeqeq --- supressed to avoid regression testing if changed
        categoryMember?.projectCategory?.name == currentCategory?.name && isActive(categoryMember.endDate)
    ).length;

    const numberOfMembersInProject = project?.projectMembers?.length;

    // eslint-disable-next-line eqeqeq --- supressed to avoid regression testing if changed
    if (numberOfMembersInCategory == numberOfMembersInProject) {
      return LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.TimeReportingProject.ProjectCategoryNumberOfMembersAll
      );
    }

    if (numberOfMembersInCategory === 1) {
      return LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.TimeReportingProject.ProjectCategoryNumberOfMember,
        undefined,
        { members: numberOfMembersInCategory.toString() }
      );
    }

    if (numberOfMembersInCategory !== numberOfMembersInProject) {
      return LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.TimeReportingProject.ProjectCategoryNumberOfMembers,
        undefined,
        { members: numberOfMembersInCategory.toString() }
      );
    }

    return "";
  };

  return <>{[timeReportingProject != null ? getLabel(timeReportingProject) : ""]}</>;
};

export default NumberOfProjectCategoryMembers;
